export default {
      id: "areas-4-usage",
      viewBox: "0 0 25 25",
      url: "/" + "assets/sprite.svg#areas-4",
      toString: function () {
        return this.url;
      }
    }